export default "__VITE_ASSET__8ecb9813__"